// @ts-nocheck
export const localeCodes =  [
  "en",
  "es",
  "fr",
  "it",
  "ru",
  "de",
  "pl"
]
export const localeLoaders = {
  en: [],
  es: [],
  fr: [],
  it: [],
  ru: [],
  de: [],
  pl: []
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/377c237d" /* webpackChunkName: "config_i18n_46config_46js_377c237d" */)
]
export const normalizedLocales = [
  {
    code: "en",
    language: "en"
  },
  {
    code: "es",
    language: "es"
  },
  {
    code: "fr",
    language: "fr"
  },
  {
    code: "it",
    language: "it"
  },
  {
    code: "ru",
    language: "ru"
  },
  {
    code: "de",
    language: "de"
  },
  {
    code: "pl",
    language: "pl"
  }
]
/** client **/

/** client-end **/